import React from 'react';
import LegalLayout, { COMPANY, H2, P, UL } from './LegalLayout';

const CookiePolicy: React.FC = () => (
  <LegalLayout
    slug="cookies"
    title="Cookie Policy"
    description="How 12and22 uses cookies and similar technologies."
  >
    <P>
      This Cookie Policy explains how {COMPANY.legalName} ({COMPANY.brand}) uses cookies and similar
      technologies on our website. It should be read together with our{' '}
      <a href="/privacy" className="text-primary-navy underline">Privacy Policy</a>.
    </P>

    <H2>What are cookies?</H2>
    <P>
      Cookies are small text files stored on your device when you visit a website. They help the site
      function, remember your preferences, and understand how the site is used.
    </P>

    <H2>Cookies we use</H2>
    <UL>
      <li><strong>Strictly necessary</strong> — required for the site and your account to work
        (authentication, session, security). These cannot be switched off.</li>
      <li><strong>Functional</strong> — remember choices such as preferences to improve your experience.</li>
      <li><strong>Analytics</strong> — help us understand usage so we can improve the Services. Set only
        where permitted.</li>
      <li><strong>Payment</strong> — our payment processor (Stripe) may set cookies to process
        transactions securely and prevent fraud.</li>
    </UL>

    <H2>Managing cookies</H2>
    <P>
      Most browsers let you refuse or delete cookies through their settings. Blocking strictly necessary
      cookies may prevent parts of the site (such as signing in) from working. Where required by law, we
      request your consent for non-essential cookies before setting them.
    </P>

    <H2>Contact</H2>
    <P>
      Questions about our use of cookies? Contact{' '}
      <a href={`mailto:${COMPANY.privacyEmail}`} className="text-primary-navy underline">{COMPANY.privacyEmail}</a>.
    </P>
  </LegalLayout>
);

export default CookiePolicy;
